// ============================================================
// useDashboard Hook
// ============================================================
// Main hook for orchestrating dashboard data fetching

import { useEffect } from 'react';
import useDashboardStore from '@/store/dashboardStore';
import { useSchool } from './useSchool';
import { useAuth } from './useAuth';

export function useDashboard(options = {}) {
  const { enabled = true } = options;
  const { schoolId } = useSchool();
  const { role } = useAuth();
  
  const loading = useDashboardStore((s) => s.loading);
  const error = useDashboardStore((s) => s.error);
  const fetchDashboardData = useDashboardStore((s) => s.fetchDashboardData);

  useEffect(() => {
    if (schoolId && role && enabled) {
      fetchDashboardData(schoolId, role);
    }
  }, [schoolId, role, fetchDashboardData, enabled]);

  return { loading, error };
}
